import React, { useEffect, useRef, useState } from "react";
import { useSelector } from "react-redux";

import Box from "@mui/material/Box";
import CircularProgress from "@mui/material/CircularProgress";

const MainScanTile4 = ({
  blueTitle,
  unboundedText,
  unboundedText1,
  boundedText,
  button_type,
  InputPlaceholder,
  numericKeyboard,
  scanValue,
  onChange,
  onSubmit,
  onOpenSearch,
  searchoptions,
  scanicon,
  scanScreen,
  onProgressiveItemClick,
  onScanHandler
}) => {
  // Redux state
  const { keyboardType, progressiveArray, progressiveLoading } = useSelector(
    (state) => state.slice
  );

  // Local state
  const [inputMode, setInputMode] = useState(
    numericKeyboard ? "numeric" : "none"
  );

  const inputRef = useRef();

  useEffect(() => {
    if (numericKeyboard) {
      showKeyboard();
    } else {
      closeKeyboard();
    }
  }, [unboundedText, boundedText, InputPlaceholder, numericKeyboard]);

  const showKeyboard = () => {
    setInputMode(numericKeyboard ? "numeric" : "text");
    inputRef.current.inputMode = numericKeyboard ? "numeric" : "text";
    inputRef.current.focus();
    // if (window.ReactNativeWebView) {
    //     window.ReactNativeWebView.postMessage(JSON.stringify({ name: 'show_keyboard' }))
    // }
  };

  const closeKeyboard = () => {
    setInputMode("none");
    inputRef.current.inputMode = "none";
    inputRef.current.focus();
  };

  const handleKeyUp = (e) => {
    if (e.key === 'Enter') {
      e.preventDefault();
      onSubmit();
    }
  };

  return (
    <div className={"cmt-10 mainScanTile backgroundColor-Type3 relative"}>
      <div className={"backgroundColor-Gradient uperScaner-div-4"}>
        {blueTitle && (
          <div className="uperSD-Text font-small pick-locations-title-1 w-100 cmt-10">
            {blueTitle}
          </div>
        )}
        <div
          style={{
            padding: boundedText
              ? "10px 10px 20px 10px"
              : "50px 10px",
          }}
        >
          <div className="uperSD-Text py-2">
            {unboundedText}
            {unboundedText1 && (
              <div className="textColor-Type2 font-smallBold">
                {unboundedText1}
              </div>
            )}
          </div>

          {boundedText && (
            <div className="uperSD-boundedText font-xlarge">{boundedText}</div>
          )}
        </div>
      </div>
      <div className="backgroundColor-Type3 scanner-div cpt-15 cmb-15">
        <div
          className={`backgroundColor-Type4 scannerInput-4 field ${
            progressiveArray && progressiveArray.data ? "" : "cmb-15"
          }`}
          style={{ width: button_type ? "80%" : "95%" }}
        >
          <input
            type={keyboardType}
            autoFocus={true}
            ref={inputRef}
            className="backgroundColor-Type4 inputscan"
            onPaste={(e) => {
              e.preventDefault();
              return false;
            }}
            onCopy={(e) => {
              e.preventDefault();
              return false;
            }}
            placeholder={InputPlaceholder}
            onClick={showKeyboard}
            inputMode={inputMode}
            value={scanValue}
            onChange={onChange}
            onKeyUp={handleKeyUp}
          />
          {
            <>
              {searchoptions && (
                <img
                  className="floatRight"
                  src={process.env.PUBLIC_URL + "/Assets/icons/search.png"}
                  alt="line"
                  onClick={onOpenSearch}
                />
              )}
              {searchoptions && scanicon && (
                <div className="Screen1line cmr-5 cml-5">
                  <img
                    className="cml-5"
                    src={process.env.PUBLIC_URL + "/Assets/icons/line176.svg"}
                    alt="line"
                  />
                </div>
              )}

              {scanicon && (
                <img
                  className="floatRight"
                  src={
                    process.env.PUBLIC_URL +
                    "/Assets/icons/noun_Barcode_2011116 2.svg"
                  }
                  alt="line"
                  onClick={async (e) => {
                    if (
                      InputPlaceholder == "Scan or enter Bin Location" ||
                      InputPlaceholder == "Scan or enter Product Code"
                    ) {
                      if (window.ReactNativeWebView) {
                        window.ReactNativeWebView.postMessage(
                          JSON.stringify({ camera: "on" })
                        );
                      }

                      const barcodeScannerPromise = new Promise((resolve) => {
                        window.barcodeScanner = function (
                          cameraState,
                          barcodeData
                        ) {
                          if (cameraState === false && barcodeData != null) {
                            resolve(barcodeData);
                          }
                        };
                      });

                      // Wait for the promise to resolve
                      const barcodeData = await barcodeScannerPromise;
                      // Set the updated scan value & submit
                      onChange(barcodeData.toString());
                      onSubmit(barcodeData.toString());
                    } else {
                      onSubmit();
                    }
                  }}
                />
              )}
            </>
          }

        </div>
        {
            button_type &&
            <img className="floatRight cml-10 cmb-15" src={process.env.PUBLIC_URL + '/Assets/icons/B3.png'} alt="line" onClick={onScanHandler} />
        }
      </div>
      {/* this code is for progressive search */}
      {progressiveArray && !progressiveArray.length ? (
        <p className="text-center text-danger mb-0">No item found</p>
      ) : null}

      {progressiveLoading ? (
        <div id="progressive-search">
          <Box sx={{ display: "flex", justifyContent: "center" }}>
            <CircularProgress size={20} thickness={4} />
          </Box>
        </div>
      ) : Array.isArray(progressiveArray) &&
        progressiveArray.length ? (
        <div id="progressive-search">
          {progressiveArray.map((item, i) => (
            <p key={i} onClick={() => onProgressiveItemClick(item)}>
              {item?.[scanScreen.progessive_search.value]}
            </p>
          ))}
        </div>
      ) : null}
    </div>
  );
};

export default MainScanTile4;
